import { getItemSession } from './setItem';

export const trackEvent = ({ eventName = 'button_click', params = {} }) => {
  if (typeof window?.gtag === 'function') {
    window.gtag('event', eventName, {
      ...params,
      utm_source: getItemSession({ key: 'utm_source' }),
      utm_medium: getItemSession({ key: 'utm_medium' }),
      utm_campaign: getItemSession({ key: 'utm_campaign' }),
      utm_term: getItemSession({ key: 'utm_term' }),
      utm_content: getItemSession({ key: 'utm_content' }),
    });
  }

  if (typeof window?.fbq === 'function') {
    window.fbq('trackCustom', eventName, {
      ...params,
      utm_source: getItemSession({ key: 'utm_source' }),
      utm_medium: getItemSession({ key: 'utm_medium' }),
      utm_campaign: getItemSession({ key: 'utm_campaign' }),
      utm_term: getItemSession({ key: 'utm_term' }),
      utm_content: getItemSession({ key: 'utm_content' }),
    });
  }
};
